const Cropper = require('cropperjs');

const { Jimp } = require("jimp");
window.Jimp = Jimp;
window.Cropper = Cropper;

export class PaintTool {
  canvas = null;
  context = null;
  image = null;
  cropper = null;
  static get StackMaxSize() {
    return 5;
  };
  undoDataStack = [];
  redoDataStack = [];
  textActive = false;
  textPosition = { x: 0, y: 0 };
  penActive = false;
  isDrag = false;
  configuretions = null;
  defaultConfiguretions = {
    toolbarItemToggle: '.tool-item-toggle',
    toolbarSubmenu: '.tool-menu',

    toolbarUndo: '#toolbarItemUndo',
    toolbarRedo: '#toolbarItemRedo',
    toolbarResize: '#toolbarItemResize',
    toolbarRotate: '#toolbar_rotate',
    toolbarBrigtness: '#toolbarItemBrigtness',
    toolbarContrast: '#toolbarItemContrast',
    toolbarFade: '#toolbarItemFade',
    toolbarTrimming: '#toolbarItemTrimming',
    toolbarGrayscale: '#toolbarItemGrayscale',
    toolbarDetail: '#toolbarItemDetail',
    toolbarText: '#toolbarItemText',
    toolbarPen: '#toolbarItemPen',

    resizeModel: '#resizeModal',
    resizeModelWidth: '.resizeModel__width',
    resizeModelHeight: '.resizeModel__height',
    resizeModelAspectKeep: '.resizeModel__aspect-keep',
    resizeModelCommit: '#resizeModalCommit',

    rotateToolboxRotateAngle: '.rotateToolbox__rotate-angle',
    brigtnessToolboxBrightness: '.brigtnessToolbox__brightness',
    contrastToolboxContrast: '.contrastToolbox__contrast',
    fadeToolboxFade: '.fadeToolbox__fade',
    toolboxRangeLabel: '.value_label',

    trimmingModal: '#trimmingModal',
    trimmingModalCanvas: 'trimmingModal__canvas',
    trimmingModalCommit: '#trimmingModalCommit',

    detailModal: '#detailModal',
    detailModalLighten: '.detailModal__lighten',
    detailModalSaturate: '.detailModal__saturate',
    detailModalSpin: '.detailModal__spin',
    detailModalRed: '.detailModal__red',
    detailModalGreen: '.detailModal__green',
    detailModalBlue: '.detailModal__blue',
    detailModalCommit: '#detailModalCommit',

    textToolbox: '#textToolbox',
    textToolboxText: '.textToolbox__text',
    textToolboxSize: '.textToolbox__size',
    textToolboxColor: '.textToolbox__color',
    textToolboxCommit: '#textToolboxCommit',

    penToolbox: '#penToolbox',
    penToolboxPenSize: '.penToolbox__size',
    penToolboxPenColor: '.penToolbox__color',
  };

  constructor(canvasId, config) {
    this.canvas = document.getElementById(canvasId);
    this.context = this.canvas.getContext('2d', {
      willReadFrequently: true
    });
    if (config) {
      this.configuretions = config;
    }
    else {
      this.configuretions = this.defaultConfiguretions;
    }

    this.bindEvents();
  }

  bindEvents() {
    let self = this;

    // ツールバー トグルイベント
    $(this.configuretions.toolbarItemToggle).on('click', function () {
      $(self.configuretions.toolbarSubmenu).addClass('hide');

      let $menu = $(this).find(self.configuretions.toolbarSubmenu);

      if ($menu.hasClass('hide')) {
        $menu.removeClass('hide');
      }
      else {
        $menu.addClass('hide');
      }
      return false;
    });

    // リサイズ確定
    $(this.configuretions.resizeModelCommit).on('click', async function () {
      let width = $(self.configuretions.resizeModelWidth).val();
      let height = $(self.configuretions.resizeModelHeight).val();

      await self.image.resize({ w: parseInt(width, 10), h: parseInt(height, 10), mode: Jimp.AUTO });

      self.writeImage();

      $(self.configuretions.resizeModel).modal('hide');

      return false;
    });

    // リサイズモーダル 幅テキスト変更時
    $(this.configuretions.resizeModelWidth).on('change', function () {
      if ($(self.configuretions.resizeModelAspectKeep).is(':checked')) {
        let rawHeight = ((parseInt($(this).val(), 10) / self.image.bitmap.width) * self.image.bitmap.height);
        $(self.configuretions.resizeModelHeight).val(rawHeight.toFixed(0));
      }
    });

    // リサイズモーダル 高さテキスト変更時
    $(this.configuretions.resizeModelHeight).on('change', function () {
      if ($(self.configuretions.resizeModelAspectKeep).is(':checked')) {
        let rawWidth = ((parseInt($(this).val(), 10) / self.image.bitmap.height) * self.image.bitmap.width);
        $(self.configuretions.resizeModelWidth).val(rawWidth.toFixed(0));
      }
    });

    // 回転ツールボックス 度数変更時
    $(this.configuretions.rotateToolboxRotateAngle).on('change', async function () {
      await self.image.rotate(parseInt($(this).val(), 10), false);

      self.writeImage();

      $(this).val(0);
      $(this).parent().find(self.configuretions.toolboxRangeLabel).text($(this).val());

      return false;
    });

    // 回転ツールボックス 度数値表示
    $(this.configuretions.rotateToolboxRotateAngle).on('input', function () {
      $(this).parent().find(self.configuretions.toolboxRangeLabel).text($(this).val());
    });

    // 明るさツールボックス 明るさ変更時
    $(this.configuretions.brigtnessToolboxBrightness).on('change', async function () {
      await self.image.brightness(parseFloat($(this).val(), 10));

      self.writeImage();

      $(this).val('1');
      $(this).parent().find(self.configuretions.brigtnessToolboxBrightness).text($(this).val());

      return false;
    });

    // 明るさツールボックス 
    $(this.configuretions.brigtnessToolboxBrightness).on('input', function () {
      $(this).parent().find(self.configuretions.toolboxRangeLabel).text($(this).val());
    });

    // コントラストツールボックス コントラスト変更
    $(this.configuretions.contrastToolboxContrast).on('change', async function () {
      await self.image.contrast(parseFloat($(this).val(), 10));

      self.writeImage();

      $(this).val('0');
      $(this).parent().find(self.configuretions.contrastToolboxContrast).text($(this).val());

      return false;
    });

    // コントラストツールボックス 数字表示
    $(this.configuretions.contrastToolboxContrast).on('input', function () {
      $(this).parent().find(self.configuretions.toolboxRangeLabel).text($(this).val());
    });

    // 不透明度ツールボックス 数字変更
    $(this.configuretions.fadeToolboxFade).on('change', async function () {
      let param = $(this).val();
      await self.image.fade(parseFloat(param, 10));

      self.writeImage();

      $(this).val('0');
      $(this).parent().find(self.configuretions.fadeToolboxFade).text($(this).val());

      return false;
    });
    // 不透明度ツールボックス 値変更
    $(this.configuretions.fadeToolboxFade).on('input', function () {
      $(this).parent().find(self.configuretions.toolboxRangeLabel).text($(this).val());
    });

    // グレースケール押下
    $(this.configuretions.toolbarGrayscale).on('click', async function () {
      await self.image.greyscale();

      self.writeImage();

      return false;
    });

    // トリミングモーダル表示前
    $(this.configuretions.trimmingModal).on('show.bs.modal', async function () {
      const tcanvas = document.getElementById(self.configuretions.trimmingModalCanvas);
      const tctx = tcanvas.getContext('2d');

      tcanvas.width = self.canvas.width;
      tcanvas.height = self.canvas.height;
      let image2 = self.context.getImageData(0, 0, self.canvas.width, self.canvas.height);

      tctx.putImageData(image2, 0, 0);
    });

    // トリミングモーダル表示
    $(this.configuretions.trimmingModal).on('shown.bs.modal', async function () {
      const tcanvas = document.getElementById(self.configuretions.trimmingModalCanvas);
      self.cropper = new Cropper(tcanvas, {
        movable: false,
        zoomable: true,
        rotatable: false,
        scalable: true
      });
    });

    // トリミングモーダル 確定
    $(this.configuretions.trimmingModalCommit).on('click', async function () {
      let trimmingCanvas = self.cropper.getCroppedCanvas();
      self.image = await Jimp.read(trimmingCanvas.toDataURL());

      self.writeImage();
      self.cropper.destroy();
      $(self.configuretions.trimmingModal).modal('hide');
      return false;
    });

    // 詳細モーダル
    $(this.configuretions.detailModalCommit).on('click', async function () {
      let list = new Array();

      if ($(self.configuretions.detailModalLighten).val() != 0) {
        if ($(self.configuretions.detailModalLighten).val() > 0) {
          list.push({ apply: 'lighten', params: [parseInt($(self.configuretions.detailModalLighten).val(), 10)] });
        }
        else {
          list.push({ apply: 'lighten', params: [-1 * parseInt($(self.configuretions.detailModalLighten).val(), 10)] });
        }
      }
      if ($(self.configuretions.detailModalSaturate).val() != 0) {
        if ($(self.configuretions.detailModalSaturate).val() > 0) {
          list.push({ apply: 'saturate', params: [parseInt($(self.configuretions.detailModalSaturate).val(), 10)] });
        }
        else {
          list.push({ apply: 'desaturate', params: [-1 * parseInt($(self.configuretions.detailModalSaturate).val(), 10)] });
        }
      }
      if ($(self.configuretions.detailModalSpin).val() != 0) {
        list.push({ apply: 'spin', params: [parseInt($(self.configuretions.detailModalSpin).val(), 10)] });
      }
      if ($(self.configuretions.detailModalRed).val() != 0) {
        list.push({ apply: 'red', params: [parseInt($(self.configuretions.detailModalRed).val(), 10)] });
      }
      if ($(self.configuretions.detailModalGreen).val() != 0) {
        list.push({ apply: 'green', params: [parseInt($(self.configuretions.detailModalGreen).val(), 10)] });
      }
      if ($(self.configuretions.detailModalBlue).val() != 0) {
        list.push({ apply: 'blue', params: [parseInt($(self.configuretions.detailModalBlue).val(), 10)] });
      }
      if (list.length > 0) {
        await self.image.color(list);

        $(self.configuretions.detailModalLighten).val('0');
        $(self.configuretions.detailModalSaturate).val('0');
        $(self.configuretions.detailModalSpin).val('0');
        $(self.configuretions.detailModalRed).val('0');
        $(self.configuretions.detailModalGreen).val('0');
        $(self.configuretions.detailModalBlue).val('0');

        self.writeImage();
      }

      $(self.configuretions.detailModal).modal('hide');

      return false;
    });

    // ツールボックスボタンの非表示
    $(document).on('click', (e) => {
      if (!$(e.target).closest(self.configuretions.toolbarItemToggle).length &&
        !$(e.target).closest(self.configuretions.toolbarSubmenu).length) {
        $(self.configuretions.toolbarSubmenu).addClass('hide');
      }
    });

    // UNDO
    $(this.configuretions.toolbarUndo).on('click', function () {
      if (self.undoDataStack.length <= 1) {
        return;
      }

      const imageData = self.context.getImageData(0, 0, self.canvas.width, self.canvas.height);
      self.redoDataStack.unshift({
        data: imageData,
        width: self.canvas.width,
        height: self.canvas.height,
      });

      var image = self.undoDataStack.shift();
      self.canvas.width = image.width;
      self.canvas.height = image.height;
      self.context.putImageData(image.data, 0, 0);
      self.reloadImage();

      $(self.configuretions.resizeModelWidth).val(image.width);
      $(self.configuretions.resizeModelHeight).val(image.height);

      return false;
    });

    $(this.configuretions.toolbarRedo).on('click', function () {
      if (self.redoDataStack.length <= 0) {
        return
      }

      const imageData = self.context.getImageData(0, 0, self.canvas.width, self.canvas.height);
      self.undoDataStack.unshift({
        data: imageData,
        width: self.canvas.width,
        height: self.canvas.height,
      });

      var image = self.redoDataStack.shift();
      self.canvas.width = image.width;
      self.canvas.height = image.height;
      self.context.putImageData(image.data, 0, 0);
      self.reloadImage();

      $(self.configuretions.resizeModelWidth).val(image.width);
      $(self.configuretions.resizeModelHeight).val(image.height);

      return false;
    });

    $(this.configuretions.toolbarText).on('click', function () {
      if (!self.textActive) {
        self.textActive = true;
        $(this).addClass('active');
      }
      else {
        self.textActive = false;
        $(this).removeClass('active');
        $(self.configuretions.textToolbox).addClass('hide');
      }

      return false;
    });

    $(this.canvas).on('mousedown', function (e) {
      if (self.textActive) {
        self.textPosition.x = e.clientX - $(this).offset().left;
        self.textPosition.y = e.clientY - $(this).offset().top;

        $(self.configuretions.textToolbox).css({ 'top': (self.textPosition.y + 10) + 'px', 'left': (self.textPosition.x + 10) + 'px' });
        $(self.configuretions.textToolbox).removeClass('hide');
      }

      if (self.penActive) {
        self.context.beginPath();
        self.isDrag = true;
      }

      return false;
    });

    $(this.canvas).on('mousemove', function (e) {
      if (self.penActive) {
        self.draw(e.offsetX, e.offsetY);
      }
    });
    $(this.canvas).on('touchmove', function (e) {
      if (self.penActive) {
        self.draw(e.offsetX, e.offsetY);
      }
    });
    $(this.canvas).on('mouseup', function (e) {
      if (self.penActive) {
        self.context.closePath();
        self.isDrag = false;
        self.writeHistory(null);
        self.reloadImage();
      }
    });
    $(this.canvas).on('touchstart', function (e) {
      if (self.penActive) {
        self.context.beginPath();
        self.isDrag = true;
      }
    });
    $(this.canvas).on('touchend', function (e) {
      if (self.penActive) {
        self.context.closePath();
        self.isDrag = false;
        self.writeHistory(null);
        self.reloadImage();
      }
    });

    $(this.configuretions.penToolboxPenSize).on('change', function () {
      self.context.lineWidth = $(this).val();
    });
    $(this.configuretions.penToolboxPenSize).on('input', function () {
      $(this).parent().parent().find(self.configuretions.toolboxRangeLabel).text($(this).val());
    });

    $(this.configuretions.penToolboxPenColor).on('change', function () {
      self.context.strokeStyle = $(this).val();
    });

    $(this.configuretions.textToolboxCommit).on('click', function () {
      let oldFont = self.context.font;
      let oldStyle = self.context.fillStyle;

      self.writeHistory(null);

      self.context.font = $(self.configuretions.textToolboxSize).val() + " serif";
      self.context.fillStyle = $(self.configuretions.textToolboxColor).val();

      self.context.fillText($(self.configuretions.textToolboxText).val(), self.textPosition.x, self.textPosition.y);

      self.context.font = oldFont;
      self.context.fillStyle = oldStyle;

      self.reloadImage();

      $(self.configuretions.textToolboxSize).val('14px');
      $(self.configuretions.textToolboxColor).val('#000000');
      $(self.configuretions.textToolboxText).val('');

      self.textActive = false;
      $(self.configuretions.toolbarText).removeClass('active');
      $(self.configuretions.textToolbox).addClass('hide');

      return false;
    });

    $(this.configuretions.toolbarPen).on('click', function () {
      if (!self.penActive) {
        self.penActive = true;
        $(this).addClass('active');
        $(self.configuretions.penToolbox).removeClass('hide');
      }
      else {
        self.penActive = false;
        $(this).removeClass('active');
        $(self.configuretions.penToolbox).addClass('hide');
      }

      return false;
    });

    $(this.configuretions.detailModalLighten).on('input', function () {
      self.setDetailValueLabel(this);
    });
    $(this.configuretions.detailModalSaturate).on('input', function () {
      self.setDetailValueLabel(this);
    });
    $(this.configuretions.detailModalSpin).on('input', function () {
      self.setDetailValueLabel(this);
    });
    $(this.configuretions.detailModalRed).on('input', function () {
      self.setDetailValueLabel(this);
    });
    $(this.configuretions.detailModalGreen).on('input', function () {
      self.setDetailValueLabel(this);
    });
    $(this.configuretions.detailModalBlue).on('input', function () {
      self.setDetailValueLabel(this);
    });
  }

  async loadImage(imageUrl) {
    this.image = await Jimp.read(imageUrl);
    this.writeImage();
  }
  async reloadImage() {
    this.image = await Jimp.read(this.canvas.toDataURL());
  }

  writeImage() {
    this.writeHistory(null);

    const imageData = new ImageData(
      Uint8ClampedArray.from(this.image.bitmap.data),
      this.image.bitmap.width,
      this.image.bitmap.height
    );
    this.canvas.width = this.image.bitmap.width;
    this.canvas.height = this.image.bitmap.height;
    this.context.putImageData(imageData, 0, 0);
    this.reloadImage();

    $(this.configuretions.resizeModelWidth).val(this.image.bitmap.width);
    $(this.configuretions.resizeModelHeight).val(this.image.bitmap.height);
  }

  writeHistory(data) {
    let d = null;
    if (data === null) {
      d = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
    }
    else {
      d = data;
    }

    this.redoDataStack = [];
    if (this.undoDataStack.length >= this.StackMaxSize) {
      this.undoDataStack.pop();
  }
    this.undoDataStack.unshift({
      data: d,
      width: this.canvas.width,
      height: this.canvas.height,
    });
  }

  draw(x, y) {
    if (!this.isDrag) {
      return;
    }
    this.context.lineTo(x, y);
    this.context.stroke();
  }

  async getBase64Data() {
    let self = this;
    let blob = await new Promise(function (resolve) {
      self.canvas.toBlob(function (result) {
        resolve(result);
      });
    });
    let base64data = await new Promise(function (resolve) {
      var reader = new FileReader();
      reader.onloadend = function () {
        resolve(reader.result)
      };
      reader.readAsDataURL(blob);
    });
    return base64data;
  }

  setDetailValueLabel(obj) {
    $(obj).closest('.row').find('.value_label').text($(obj).val());
  }

  async loadFileImage(file) {
    // ファイル読み込みに成功したときの処理
    let url = await new Promise(function(resolve) {
      var reader = new FileReader();

      reader.onload = function() {
          resolve(reader.result);
      }
      reader.readAsDataURL(file);
    });
    var img = new Image();
    await new Promise(function(resolve) {
      img.src = url;
      img.onload = function() {
          resolve();
      }
    });
    this.canvas.width = img.naturalWidth;
    this.canvas.height = img.naturalHeight;
    this.context.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight);
    $(this.configuretions.resizeModelWidth).val(img.naturalWidth);
    $(this.configuretions.resizeModelHeight).val(img.naturalHeight);

    await this.reloadImage();
    this.writeHistory(null);
  }
}
